import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Box, 
  Container, 
  Typography, 
  Button, 
  Paper, 
  Fade,
  Grid,
  Divider
} from '@mui/material';
import { 
  Home as HomeIcon, 
  SentimentDissatisfied as SadIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/');
  };

  const goBack = () => {
    navigate(-1);
  };

  return (
    <Container maxWidth="md">
      <Fade in={true} timeout={800}>
        <Paper 
          elevation={3} 
          sx={{ 
            p: 4, 
            my: 8, 
            borderRadius: 2,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            border: '1px solid #e0e0e0'
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ textAlign: 'center', mb: { xs: 2, md: 0 } }}>
                <Box
                  component="img"
                  src="https://cdn-icons-png.flaticon.com/512/1160/1160405.png"
                  alt="404 İllüstrasyon"
                  sx={{ 
                    width: '100%', 
                    maxWidth: 240,
                    animation: 'float 3s ease-in-out infinite',
                    '@keyframes float': {
                      '0%': { transform: 'translateY(0px)' },
                      '50%': { transform: 'translateY(-10px)' },
                      '100%': { transform: 'translateY(0px)' }
                    }
                  }}
                />
              </Box>
            </Grid>
            
            <Grid item xs={12} md={6}>
              <Box sx={{ px: 2 }}>
                <Typography 
                  variant="h2" 
                  component="h1" 
                  sx={{ 
                    fontWeight: 'bold',
                    color: 'primary.main',
                    mb: 1
                  }}
                >
                  404
                </Typography>
                
                <Typography variant="h5" component="h2" gutterBottom fontWeight="bold">
                  Sayfa Bulunamadı
                </Typography>
                
                <Typography variant="body1" color="text.secondary" paragraph>
                  Aradığınız sayfa mevcut değil veya taşınmış olabilir. 
                  Lütfen URL'yi kontrol edin veya aşağıdaki seçenekleri deneyin.
                </Typography>
                
                <Divider sx={{ my: 2 }} />
                
                <Box sx={{ mt: 3, display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
                  <Button
                    variant="contained"
                    startIcon={<HomeIcon />}
                    onClick={goHome}
                    fullWidth
                  >
                    Ana Sayfaya Dön
                  </Button>
                  
                  <Button
                    variant="outlined"
                    startIcon={<ArrowBackIcon />}
                    onClick={goBack}
                    fullWidth
                  >
                    Önceki Sayfaya Dön
                  </Button>
                </Box>
              </Box>
            </Grid>
            
            <Grid item xs={12}>
              <Box sx={{ 
                mt: 2, 
                p: 2, 
                bgcolor: 'rgba(0, 0, 0, 0.03)', 
                borderRadius: 1, 
                display: 'flex', 
                alignItems: 'center' 
              }}>
                <SadIcon sx={{ mr: 1, color: 'text.secondary' }} />
                <Typography variant="body2" color="text.secondary">
                  Eğer bu hatanın bir hata olduğunu düşünüyorsanız, lütfen site yöneticisiyle iletişime geçin.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Fade>
    </Container>
  );
};

export default NotFoundPage;